import axios from "@utils/api/axiosInstance";
import { printInConsole } from "@utils/devtools/utils";
import { FEED_TYPES, LANGUAGE } from "@utils/constants";

async function createBlog({ data, postType, files, accessToken }) {
  //console.log("Create post data => ", data);
  if (postType === FEED_TYPES.IMAGE) {
    const images = await uploadBlogImage({ files, accessToken });
    if (images) data.images = images;
  }
  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("blog"),
    data: data,
  }).catch((err) => {
    printInConsole(err);
  });

  //console.log("Create blog response => ", response);

  if (response?.data?.success) return response.data;

  return response.data;
}

async function updateBlog({ data, accessToken }) {
  const response = await axios({
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    method: "PUT",
    url: encodeURI("blog"),
    data: data,
  }).catch((err) => {
    printInConsole(err);
  });

  // console.log("Update blog fun => ", data);

  // console.log("Update blog response => ", response);

  if (response?.data?.success) return response?.data;

  return response?.data;
}

async function deleteBlog({ blogID, accessToken }) {
  const req_data = {
    blogID: blogID,
  };

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "DELETE",
    url: encodeURI(`blog`),
    data: req_data,
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Delete blog response => ", response);

  if (response?.data) return response.data.success;

  return null;
}

async function getBlogPosts({ page }) {
  /*
  accessToken --> required
  */

  let data = null,
    err = null;

  let reqOptions;
  if (!page) {
    reqOptions = {
      method: "GET",
      url: encodeURI(`blog/all`),
    };
  } else {
    reqOptions = {
      method: "GET",
      url: encodeURI(`blog/all?page=${page}`),
    };
  }

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(err);
  });

  //console.log("Blogs Fetch response => ", response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}
async function getPopularBlogPosts({ blogID }) {
  /*
  accessToken --> required
  */

  let data = null,
    err = null;

  let reqOptions = {
    method: "GET",
    url: encodeURI(`blog/popular?blogID=${blogID}`),
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(err);
  });

  //console.log("Blogs Fetch response => ", response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

async function getBlogsByCategory({ categoryUrl, blogTs }) {
  let data = null,
    err = null;

  let reqOptions;

  if (blogTs) {
    reqOptions = {
      method: "GET",
      url: encodeURI(
        `blog/category/v2?categoryUrl=${categoryUrl}&blogTs=${blogTs}`
      ),
    };
  } else {
    reqOptions = {
      method: "GET",
      url: encodeURI(`blog/category/v2?categoryUrl=${categoryUrl}`),
    };
  }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    // console.error(err); // Print error to console using console.error()
  });

  //console.log("Blogs Fetch response => ", response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

async function getSearchedBlogPosts({ page, search }) {
  /*
  accessToken --> required
  */

  let data = null,
    err = null;

  let reqOptions;
  if (!page) {
    reqOptions = {
      method: "GET",
      url: encodeURI(`search/blogs?query=${search}`),
    };
  } else {
    reqOptions = {
      method: "GET",
      url: encodeURI(`search/blogs?query=${search}&page=${page}`),
    };
  }

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(err);
  });

  //console.log("Blogs Fetch response => ", response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

async function getSearchedBlogPostsByCategory({ page, categoryUrl, query }) {
  /*
  accessToken --> required
  */

  let data = null,
    err = null;

  let reqOptions;
  if (!page) {
    reqOptions = {
      method: "GET",
      url: encodeURI(
        `blog/category/search?query=${query}&categoryUrl=${categoryUrl}`
      ),
    };
  } else {
    reqOptions = {
      method: "GET",
      url: encodeURI(
        `blog/category/search?query=${query}&page=${page}&categoryUrl=${categoryUrl}`
      ),
    };
  }

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(err);
  });

  //console.log("Blogs Fetch response => ", response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

async function getSingleBlogPost({ urlExtension, accessToken }) {
  /*
  accessToken --> required
  */

  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(`blog?blogID=${urlExtension}`),
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(err);
  });

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

async function likeBlogPost(blogID, accessToken) {
  const req_data = {
    blogID: blogID,
  };

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("blog/like"),
    data: req_data,
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Blog Like response", response);
  return response?.data;
}

async function dislikeBlogPost(blogID, accessToken) {
  const req_data = {
    blogID: blogID,
  };

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "DELETE",
    url: encodeURI(`blog/like`),
    data: req_data,
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Blog Unlike response", response);
  return response?.data;
}

async function reportBlogPost(
  uid,
  postID,
  toggleReportModal,
  toggleRepSuccessModal,
  accessToken
) {
  const req_data = {
    uid: uid,
    postID: postID,
  };

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI(`blog/report`),
    data: req_data,
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Blog report response", response);
  return response?.data;
}

async function uploadBlogImage({ files, accessToken }) {
  /*
  Upload dp and cover of community
  */

  const formData = new FormData();
  files.forEach((item) => {
    formData.append("image", item);
  });

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("blog/image"),
    data: formData,
  }).catch((err) => printInConsole(err));

  printInConsole("uploadImage => ", response);

  // ! To be changed
  // if (response?.data?.success) return response.data.response;
  // return null;
  return response?.data;
}

async function commentBlog({ blogID, comment, linkMetaData, accessToken }) {
  const data = {
    blogID: blogID,
    comment,
    linkMetaData,
  };
  // console.log("comment blog===>", data);
  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("blog/comment"),
    data: data,
  }).catch((err) => {
    printInConsole(err);
  });

  // console.log("Create blog comment response => ", response);

  if (response?.data) return response.data;
  else if (
    response?.data?.success === false &&
    response?.data?.message === "Comment contains vulgar words"
  )
    return response.data;
  return response?.data;
}

async function getCommentBlog({ blogID, ts, accessToken, cancelToken }) {
  let data = null,
    err = null;
  if (!ts) {
    ts = Date.now();
  }
  if (!accessToken) {
    accessToken = "";
  }

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI(`blog/comment/all?blogID=${blogID}&ts=${ts}`),
    cancelToken: cancelToken,
  }).catch((error) => {
    err = error;
    printInConsole(err);
  });

  //console.log("Single Blog Comment Fetch response => ", response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

async function deleteCommentBlog({ commentID, accessToken }) {
  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "DELETE",
    url: encodeURI(`blog/comment`),
    data: { commentID },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Blog Comment delete response", response);
  // if (response?.data?.success) data = response?.data?.response;
  // else if (response?.data?.message) err = response.data.message;

  if (response) {
    return response.data.success;
  }
}

async function getBlogLikesList({ blogID, ts, accessToken }) {
  let data = null,
    err = null;
  if (!ts) {
    ts = Date.now();
  }

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI(`blog/like/?blogID=${blogID}&ts=${ts}`),
  }).catch((error) => {
    err = error;
    printInConsole(err);
  });

  //printInConsole("Single Blog Comment Fetch response => ", response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

async function getBlogCategories({ accessToken, language = LANGUAGE.ENGLISH }) {
  let data = null,
    err = null;

  const response = await axios({
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    method: "GET",
    url: encodeURI(`admin/home/getAllBlogCategory?language=${language}`),
  }).catch((error) => {
    err = error;
    printInConsole(err);
  });

  // printInConsole("Blog categories Fetch response => ", response);

  if (response?.data?.success) data = response?.data?.response;
  else if (response?.data?.message) err = response.data.message;

  return { data, err };
}

export {
  createBlog,
  updateBlog,
  deleteBlog,
  getBlogPosts,
  getPopularBlogPosts,
  getSingleBlogPost,
  uploadBlogImage,
  commentBlog,
  getCommentBlog,
  deleteCommentBlog,
  getBlogsByCategory,
  likeBlogPost,
  dislikeBlogPost,
  reportBlogPost,
  getBlogLikesList,
  getBlogCategories,
  getSearchedBlogPostsByCategory,
  getSearchedBlogPosts,
};
